function parseJSON<T>(value: string | null): T | undefined {
  try {
    return value === 'undefined' ? undefined : JSON.parse(value ?? '');
  } catch (error) {
    // console.log('parsing error on', { value });
    return undefined;
  }
}

export function readLocalStorage<T = undefined>(key: string, initialValue: T): T {
  // Prevent build error "window is undefined" but keep keep working
  if (typeof window === 'undefined') {
    return initialValue;
  }
  try {
    const item = window.localStorage.getItem(key);
    return item ? (parseJSON<T>(item) as T) : initialValue;
  } catch (error) {
    console.warn(`Error reading localStorage key “${key}”:`, error);
    return initialValue;
  }
}

export function setLocalStorage<T>(key: string, value: T): boolean {
  // Prevent build error "window is undefined" but keeps working
  if (typeof window === 'undefined') {
    console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
    return false;
  }
  try {
    // Save to local storage
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(`Error setting localStorage key “${key}”:`, error);
  }
  return false;
}

export function deleteLocalStorage(key: string): boolean {
  // Prevent build error "window is undefined" but keeps working
  if (typeof window === 'undefined') {
    console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
    return false;
  }
  try {
    // Save to local storage
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`Error setting localStorage key “${key}”:`, error);
  }
  return false;
}

export class LocalStorageKeys {
  static Ref: string = 'ref';
  static PropertyInfoContext: string = 'propertyInfoContext';
  static SessionContext: string = 'sessionContext';
  static CookiesAreSet: string = 'cookiesAreSet';
  static InteractionCookies: string = 'interactionCookies';
  static ExperienceCookies: string = 'experienceCookies';
  static MeasurementCookies: string = 'measurementCookies';
  static IsBannerVisible: string = 'isBannerVisible';
  static RequestedByUser: string = 'requestedByUser';
  static PaymentsContext: string = 'paymentsContext';
}
